import {
  MuiThemeProvider,
  createMuiTheme,
  withStyles,
} from "@material-ui/core/styles";
import classNames from "classnames";
import moment from "moment-timezone";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import HeaderBar from "../components/header/HeaderBar";
import NewTournamentDialog from "../components/NewTournamentDialog";
import PageErrorBoundary from "../components/PageErrorBoundary";
import { TournamentRoutes } from "../components/routes/TournamentRoutes";
import SupportDrawer from "../components/SupportDrawer";
import TournamentNav from "../components/TournamentNav";
import TournamentNotFound from "../components/TournamentNotFound";
import FinishedDialog from "../components/FinishedDialog";
import UpgradeButton from "../components/UpgradeButton";
import UpgradeDialog from "../components/UpgradeDialog";
import { defaultColor } from "../constants/DefaultColor";
import { languages } from "../constants/languages";
// import Snackbar from "@material-ui/core/Snackbar";
// import SnackbarContent from "@material-ui/core/SnackbarContent";
// import Button from "@material-ui/core/Button";
// import green from "@material-ui/core/colors/green";

// const upgradeLogo = require("../img/0present.png");
const upgradeLogoNormal = require("../img/trophy-icon.png");

const styles = (theme) => ({
  content: {
    flexGrow: 1,
    [theme.breakpoints.up("md")]: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginRight: 0,
    },
  },
  contentShift: {
    [theme.breakpoints.up("md")]: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 310,
    },
  },
});

class TournamentContainer extends Component {
  state = {
    mobileOpen: false,
    selectedScreen: undefined,
    tournament: undefined,
    tournamentLoaded: false,
    divisions: [],
    divisionsObject: {},
    userStatus: {},
    userStatusLoaded: false,
    tournamentStatus: {},
    tournamentStatusLoaded: false,
    upgradeDialogOpen: false,
    finishedDialogOpen: false,
    forceUpgrade: false,
    admin: undefined,
    supportOpen: false,
    notFound: false,
  };

  handleDrawerOpen = () => {
    this.setState({ supportOpen: true });
  };

  handleDrawerClose = () => {
    this.setState({ supportOpen: false });
  };

  handleClose = () => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournamentId)
      .update({ new: null });
  };

  // handleCloseOffer = () => {
  //   window.firebase
  //     .firestore()
  //     .collection("tournaments")
  //     .doc(this.props.tournamentId)
  //     .update({ seenOffer: true });
  // };

  toggleUpgradeDialog = () => {
    if (this.state.upgradeDialogOpen) {
      this.setState({ upgradeDialogOpen: false });
      return;
    }
    // Finished tournaments cannot be upgraded; user must copy first.
    if ((this.state.tournamentStatus || {}).closed) {
      this.setState({ finishedDialogOpen: true });
      return;
    }
    if (window.firebase.analytics) {
      window.firebase.analytics().logEvent("upgrade_button_pressed");
    }
    this.setState({ upgradeDialogOpen: true });
  };

  toggleFinishedDialog = () => {
    this.setState({ finishedDialogOpen: !this.state.finishedDialogOpen });
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  handleBack = () => {
    this.props.history.push("/");
  };

  handleNavClick = (e, screen) => {
    this.setState({
      selectedScreen: screen,
      mobileOpen: !this.state.mobileOpen,
    });
  };

  handleNavRoute = (e, route) => {
    this.props.history.push("/tournament/" + this.props.tournamentId + route);
  };

  handleFeaturesClick = (e) => {
    e.preventDefault();
    this.props.history.push("/features");
  };

  setCorrectScreen = () => {
    let urlPath = window.location.pathname;
    var urlParts = urlPath.split("/");
    let currentTab = urlParts[3];

    this.setState({ selectedScreen: currentTab });
  };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setCorrectScreen();
    }
  }

  componentDidMount = () => {
    this.setCorrectScreen();
    this.unsubscribeTournament = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournamentId)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            let tournament = doc.data();
            tournament[".key"] = this.props.tournamentId;
            let forceUpgrade = false;
            if (tournament.requireUpgrade && !tournament.status) {
              forceUpgrade = true;
            }
            this.setState({
              tournament: tournament,
              tournamentLoaded: true,
              forceUpgrade: forceUpgrade,
            });
            // set default fields
            if (!tournament.fields) {
              window.firebase
                .firestore()
                .collection("tournaments")
                .doc(this.props.tournamentId)
                .update({
                  fields: {},
                });
            }

            // load userStatus
            if (this.state.userStatusLoaded === false) {
              this.loadUserStatus(tournament.uid);
            }
          } else {
            this.setState({ notFound: true });
          }
        },
        (error) => {
          if (error.code === "permission-denied") {
            this.setState({ notFound: true });
          }
        }
      );

    this.unsubscribeDivisions = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournamentId)
      .collection("divisions")
      .onSnapshot(
        (querySnapshot) => {
          let divisions = [];
          let divisionsObject = {};
          querySnapshot.forEach(function (doc) {
            let division = doc.data();
            division["id"] = doc.id;
            divisions.push(division);
            divisionsObject[doc.id] = doc.data();
          });
          this.setState({
            divisions: divisions,
            divisionsObject: divisionsObject,
          });
        },
        (error) => {
          if (error.code === "permission-denied") {
            this.setState({ notFound: true });
          }
        }
      );

    this.unsubscribe2 = window.firebase
      .firestore()
      .collection("tournamentStatus")
      .doc(this.props.tournamentId)
      .onSnapshot(
        (doc) => {
          let tournamentStatus = doc.data();
          this.setState({
            tournamentStatus: tournamentStatus || {},
            tournamentStatusLoaded: true,
          });
        },
        (error) => {
          if (error.code === "permission-denied") {
            this.setState({ notFound: true });
          }
        }
      );

    if (this.props.user) {
      this.unsubscribeAdmin = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournamentId)
        .collection("admins")
        .doc(this.props.user.uid)
        .onSnapshot(
          (doc) => {
            if (doc.exists) {
              let admin = doc.data();
              admin["id"] = doc.id;
              let urlPath = window.location.pathname;
              var urlParts = urlPath.split("/");
              let currentTab = urlParts[3];
              if (currentTab === "settings" && !admin.manageGeneral) {
                if (admin.manageTeams) {
                  this.props.history.push(
                    "/tournament/" + this.props.tournamentId + "/teams"
                  );
                } else if (admin.manageFormat) {
                  this.props.history.push(
                    "/tournament/" + this.props.tournamentId + "/structure"
                  );
                } else if (admin.manageSchedule) {
                  this.props.history.push(
                    "/tournament/" + this.props.tournamentId + "/schedule"
                  );
                } else if (admin.managePresentation) {
                  this.props.history.push(
                    "/tournament/" + this.props.tournamentId
                  );
                } else if (admin.manageResults) {
                  this.props.history.push(
                    "/tournament/" + this.props.tournamentId + "/results"
                  );
                }
              }

              this.setState({ admin: admin });
            } else {
              this.setState({ admin: undefined });
            }
          },
          (error) => {
            console.log("error admins");
          }
        );
    }
  };

  loadUserStatus = (uid) => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("userStatus")
      .doc(uid)
      .onSnapshot((doc) => {
        let userStatus = doc.data();
        this.setState({ userStatus: userStatus || {}, userStatusLoaded: true });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribeTournament();
    this.unsubscribeDivisions();
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe2();
    if (this.unsubscribeAdmin) {
      this.unsubscribeAdmin();
    }
  };

  render() {
    const classes = this.props.classes;
    const theme = createMuiTheme({
      palette: {
        primary: {
          main: (this.state.tournament || {}).color || defaultColor,
        },
        secondary: {
          light: "#ff5131",
          main: "#d50000",
          dark: "#9b0000",
        },
        background: {
          default: "#ffffff",
        },
      },
    });
    let toRender = <div />;
    if (this.state.notFound) {
      toRender = (
        <div>
          <HeaderBar userData={this.props.userData} />
          <TournamentNotFound handleBack={this.handleBack} />
        </div>
      );
    } else if (
      this.state.tournament &&
      this.state.divisions.length > 0 &&
      this.state.userStatusLoaded &&
      this.state.tournamentStatusLoaded
    ) {
      if (
        this.state.tournament.uid === this.props.user.uid ||
        this.props.admins.indexOf(this.props.user.uid) !== -1 ||
        this.state.admin !== undefined
      ) {
        // The account-level userStatus wins whenever the user has a paid
        // tier (Worldclass/Legendary/Pro applies to every tournament they
        // own). Fall back to the tournament's own status when the user has
        // no subscription (status 0 = Amateur, or unset).
        const userStatusValue = this.state.userStatus.status;
        const tournamentStatusValue = this.state.tournamentStatus.status;
        const status =
          userStatusValue > 0 ? userStatusValue : tournamentStatusValue || 0;
        // Only Amateur (0) and Worldclass (1) still have an upgrade path
        // (to Worldclass / Legendary). Legendary (2) is the top tier and
        // Pro (3) is a separate esports track with no further upgrade.
        const canUpgrade = status === 0 || status === 1;

        let showDrawer = true;
        if (
          (this.state.selectedScreen === "new" ||
            this.state.selectedScreen === "nvd") &&
          this.state.supportOpen === false
        ) {
          showDrawer = false;
        }
        moment.tz.setDefault(
          this.state.tournament.timezone || "Europe/Amsterdam"
        );
        toRender = (
          <MuiThemeProvider theme={theme}>
            <HeaderBar
              handleDrawerToggle={this.handleDrawerToggle}
              isTournament={true}
              canUpgrade={canUpgrade}
              tournament={this.state.tournament}
              handleBack={this.handleBack}
              upgradeButton={
                <UpgradeButton
                  canUpgrade={canUpgrade}
                  upgradeLogo={upgradeLogoNormal}
                  status={status}
                  toggleUpgradeDialog={this.toggleUpgradeDialog}
                />
              }
              new={this.state.tournament.new}
              handleOpen={this.handleDrawerOpen}
              handleClose={this.handleDrawerClose}
              drawerOpen={this.state.supportOpen}
              userData={this.props.userData}
            />
            <TournamentNav
              tournament={this.state.tournament}
              new={this.state.tournament.new}
              mobileOpen={this.state.mobileOpen}
              handleDrawerToggle={this.handleDrawerToggle}
              handleNavClick={this.handleNavClick}
              handleBack={this.handleBack}
              handleNavRoute={this.handleNavRoute}
              selectedScreen={this.state.selectedScreen}
              tournamentAdmin={this.state.admin}
            >
              {/* Routes */}
              <main
                className={classNames(classes.content, {
                  [classes.contentShift]:
                    this.state.supportOpen &&
                    this.state.selectedScreen !== "new",
                })}
              >
                <PageErrorBoundary
                  resetKey={
                    this.props.location.pathname + this.props.location.search
                  }
                >
                  <TournamentRoutes
                    tournament={this.state.tournament}
                    divisions={this.state.divisions}
                    divisionsObject={this.state.divisionsObject}
                    userStatus={this.state.userStatus}
                    tournamentStatus={this.state.tournamentStatus}
                    user={this.props.user}
                    tournamentAdmin={this.state.admin}
                    supportOpen={this.state.supportOpen}
                    handleDrawerClose={this.handleDrawerClose}
                    userData={this.props.userData}
                    setAuthListener={this.props.setAuthListener}
                  />
                </PageErrorBoundary>
              </main>
              {showDrawer && (
                <SupportDrawer
                  open={this.state.supportOpen}
                  handleClose={this.handleDrawerClose}
                  handleFeaturesClick={this.handleFeaturesClick}
                />
              )}
              <UpgradeDialog
                open={
                  !(this.state.tournamentStatus || {}).closed &&
                  (this.state.upgradeDialogOpen ||
                    (this.state.forceUpgrade &&
                      this.state.userStatus.status !== 1 &&
                      this.state.userStatus.status !== 2))
                }
                toggleDialog={this.toggleUpgradeDialog}
                title={languages.upgrade.upgradeTournament}
                description={languages.upgrade.upgradeText1}
                tournament={this.state.tournament}
                user={this.props.user}
                userData={this.props.userData}
                tournamentStatus={this.state.tournamentStatus}
              />
              <FinishedDialog
                open={this.state.finishedDialogOpen}
                handleClose={this.toggleFinishedDialog}
              />
              <NewTournamentDialog
                open={this.state.tournament.new === false}
                handleClose={this.handleClose}
                handleDrawerOpen={this.handleDrawerOpen}
                tournament={this.state.tournament}
              />
              {/* Snackbar for discount offer */}
              {/* <Snackbar
                style={{ maxWidth: 350 }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                open={canUpgrade && !this.state.tournament.seenOffer}
                onClose={this.handleCloseOffer}
              >
                <SnackbarContent
                  style={{ backgroundColor: green[600] }}
                  aria-describedby="message-id"
                  message={
                    <div id="message-id">
                      <div style={{ width: 280, textAlign: "center" }}>
                        <img style={{ height: 40 }} src={upgradeLogo} alt="" />
                      </div>
                      {languages.upgrade.offer}
                    </div>
                  }
                  action={[
                    <Button
                      key={"1"}
                      style={{ color: "white" }}
                      variant="text"
                      color="default"
                      onClick={() => {
                        this.handleCloseOffer();
                        this.toggleUpgradeDialog();
                      }}
                    >
                      {languages.upgrade.seePackages}
                    </Button>
                  ]}
                />
              </Snackbar> */}
            </TournamentNav>
          </MuiThemeProvider>
        );
        if (
          this.state.admin !== undefined &&
          !(
            this.state.admin.manageGeneral ||
            this.state.admin.manageTeams ||
            this.state.admin.manageFormat ||
            this.state.admin.manageSchedule ||
            this.state.admin.managePresentation ||
            this.state.admin.manageResults
          )
        ) {
          toRender = (
            <div>
              <HeaderBar
                isTournament={true}
                handleBack={this.handleBack}
                tournament={this.state.tournament}
                userData={this.props.userData}
              />
              <div
                style={{ marginTop: 100, width: "100%", textAlign: "center" }}
              >
                {languages.admins.noRights}
              </div>
            </div>
          );
        }
      } else {
        toRender = (
          <div>
            <HeaderBar
              handleBack={this.handleBack}
              userData={this.props.userData}
            />
          </div>
        );
      }
    }

    return toRender;
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(TournamentContainer)
);
